var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',_vm._b({attrs:{"label":_vm.$t('Show Delivery Time')},model:{value:(_vm.showDeliveryTime),callback:function ($$v) {_vm.showDeliveryTime=$$v},expression:"showDeliveryTime"}},'switch-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }